import React from "react";

import '../styles/buttons/button.scss';

import iconProcess from '../images/icons/buttons/Loader.svg';
import iconDone from '../images/icons/buttons/Done.svg';

const Button = ({ children, click = () => {}, className = '', type = 'text', status = 'default', disabled = false }) => {
    const classes = React.useMemo(() => {
        let cls = 'Button';
        cls += className ? ' ' + className : '';
        cls += ' Button_status_' + status;

        return cls;
    }, [className, status]);

    return (
        <button onClick={() => click()} type={type} className={classes} disabled={disabled}>
            <span className="Button-Text">{children}</span>
            <span className="Button-Loader">
                <img className='loading' src={iconProcess} alt=""/>
            </span>
            <span className="Button-Done">
                <img src={iconDone} alt=""/>
            </span>
        </button>
    )
};

export default Button;
